import Box from '@mui/material/Box';
import { renderElement } from 'lib/country-flag';
import withGridCellParams from './withGridCellParams';

const CountryISO = withGridCellParams(({ value }) => (
    <>
        {Boolean(value) && (
            <Box
                display='flex'
                columnGap={2}
            >
                {renderElement(`${value}`)}
                <span>{value}</span>
            </Box>
        )}
    </>
));

export default CountryISO;
